export default "__VITE_ASSET__721a79bb__"